import { Layout } from "antd";

const { Content } = Layout;

const PassportLayout = ({ children }) => (
  <Layout>
    <Content>{children}</Content>
  </Layout>
);

export default PassportLayout;
